export const HeadingWithDescription = ({containerClass, headingOne, headingTow, description}) => {
  return (
    <div className={containerClass}>
        <p className="text-white font-oxanium text-5xl font-semibold text-center">{headingOne} <span className="text-[#4BBACE]">{headingTow}</span></p>
        <p className="absolute bg-gradient-to-r from-white to-[#52BBD4] text-transparent bg-clip-text font-lato sm:text-xl mt-4 left-1/2 -translate-x-1/2 text-center">{description}</p>
    </div>
  )
}
